// view candidate details
export const VIEW_JOB = "VIEW_JOB";
export const VIEW_JOB_SUCCESS = "VIEW_JOB_SUCCESS";
export const VIEW_JOB_ERROR = "VIEW_JOB_ERROR";

// matching candidate
export const GET_MATCHING_CANDIDATE = "GET_MATCHING_CANDIDATE";
export const GET_MATCHING_JOB_BOARD_CANDIDATE =
  "GET_MATCHING_JOB_BOARD_CANDIDATE";
export const GET_MATCHING_CANDIDATE_SUCCESS = "GET_MATCHING_CANDIDATE_SUCCESS";
export const GET_MATCHING_CANDIDATE_ERROR = "GET_MATCHING_CANDIDATE_ERROR";
export const GET_MATCHING_JOB_BOARD_CANDIDATE_SUCCESS =
  "GET_MATCHING_JOB_BOARD_CANDIDATE_SUCCESS";
// matched candidate detail
export const GET_MATCHED_CANDIDATE_DETAIL = "GET_MATCHED_CANDIDATE_DETAIL";
export const GET_MATCHED_CANDIDATE_DETAIL_SUCCESS =
  "GET_MATCHED_CANDIDATE_DETAIL_SUCCESS";
export const GET_MATCHED_CANDIDATE_DETAIL_ERROR =
  "GET_MATCHED_CANDIDATE_DETAIL_ERROR";

//similar jobs
export const GET_SIMILAR_JOB_DETAIL = "GET_SIMILAR_JOB_DETAIL";
export const GET_SIMILAR_JOB_DETAIL_SUCCESS = "GET_SIMILAR_JOB_DETAIL_SUCCESS";
export const GET_SIMILAR_JOB_DETAIL_ERROR = "GET_SIMILAR_JOB_DETAIL_ERROR";

// similar job detail
export const GET_SELECTED_JOB_DETAIL = "GET_SELECTED_JOB_DETAIL";
export const GET_SELECTED_JOB_DETAIL_SUCCESS =
  "GET_SELECTED_JOB_DETAIL_SUCCESS";
export const GET_SELECTED_JOB_DETAIL_ERROR = "GET_SELECTED_JOB_DETAIL_ERROR";

// get candidate job map
export const GET_MAPPED_JOB_CANDIDATE_DETAIL =
  "GET_MAPPED_JOB_CANDIDATE_DETAIL";
export const GET_MAPPED_JOB_CANDIDATE_DETAIL_SUCCESS =
  "GET_MAPPED_JOB_CANDIDATE_DETAIL_SUCCESS";
export const GET_MAPPED_JOB_CANDIDATE_DETAIL_ERROR =
  "GET_MAPPED_JOB_CANDIDATE_DETAIL_ERROR";

// delete candidateJob map
export const DELETE_MAPPED_JOB_CANDIDATE = "DELETE_MAPPED_JOB_CANDIDATE";
export const DELETE_MAPPED_JOB_CANDIDATE_SUCCESS =
  "DELETE_MAPPED_JOB_CANDIDATE_SUCCESS";
export const DELETE_MAPPED_JOB_CANDIDATE_ERROR =
  "DELETE_MAPPED_JOB_CANDIDATE_ERROR";

// set candidateJob map
export const SET_MAPPED_JOB_CANDIDATE_DETAIL =
  "SET_MAPPED_JOB_CANDIDATE_DETAIL";
export const SET_MAPPED_JOB_CANDIDATE_DETAIL_SUCCESS =
  "SET_MAPPED_JOB_CANDIDATE_DETAIL_SUCCESS";
export const SET_MAPPED_JOB_CANDIDATE_DETAIL_ERROR =
  "SET_MAPPED_JOB_CANDIDATE_DETAIL_ERROR";

// Bulk map candidates to job

export const BULK_MAP_CANDIDATES_TO_JOB = "BULK_MAP_CANDIDATES_TO_JOB";
export const BULK_MAP_CANDIDATES_TO_JOB_SUCCESS =
  "BULK_MAP_CANDIDATES_TO_JOB_SUCCESS";
export const BULK_MAP_CANDIDATES_TO_JOB_ERROR =
  "BULK_MAP_CANDIDATES_TO_JOB_ERROR";

// matched candidate update
export const UPDATE_MAPPED_CANDIDATE = "UPDATE_MAPPED_CANDIDATE";
export const UPDATE_MAPPED_CANDIDATE_SUCCESS =
  "UPDATE_MAPPED_CANDIDATE_SUCCESS";
export const UPDATE_MAPPED_CANDIDATE_ERROR = "UPDATE_MAPPED_CANDIDATE_ERROR";

export const CLOSE_JOB = "CLOSE_JOB";
export const CLOSE_JOB_SUCCESS = "CLOSE_JOB_SUCCESS";
export const CLOSE_JOB_FAILED = "CLOSE_JOB_FAILED";
export const EXTEND_JOB = "EXTEND_JOB";
export const EXTEND_JOB_SUCCESS = "EXTEND_JOB_SUCCESS";
export const EXTEND_JOB_FAILED = "EXTEND_JOB_FAILED";

export const OTHER_JOB_DETAILS = "OTHER_JOB_DETAILS";
export const OTHER_JOB_DETAILS_SUCCESS = "OTHER_JOB_DETAILS_SUCCESS";
export const OTHER_JOB_DETAILS_FAILED = "OTHER_JOB_DETAILS_FAILED";

// Google jobDetails

export const GOOGLE_JOB_DETAILS = "GOOGLE_JOB_DETAILS";
export const GOOGLE_JOB_DETAILS_SUCCESS = "GOOGLE_JOB_DETAILS_SUCCESS";
export const GOOGLE_JOB_DETAILS_FAILED = "GOOGLE_JOB_DETAILS_FAILED";

// add candidate

export const ADD_CANDIDATE = "ADD_CANDIDATE";
export const ADD_CANDIDATE_SUCCESS = "ADD_CANDIDATE_SUCCESS";
export const ADD_CANDIDATE_FAILED = "ADD_CANDIDATE_FAILED";

//send reminder
export const SEND_CANDIDATE_INTEREST_REMINDER =
  "SEND_CANDIDATE_INTEREST_SEND_REMINDER";
export const SEND_CANDIDATE_INTEREST_REMINDER_SUCCESS =
  "SEND_CANDIDATE_INTEREST_REMINDER_SUCCESS";
export const SEND_CANDIDATE_INTEREST_REMINDER_FAILED =
  "SEND_CANDIDATE_INTEREST_REMINDER_FAILED";

// JOB LISTING SUGGESTIONS
export const JOB_LISTING_SUGGESTIONS = "JOB_LISTING_SUGGESTIONS";
export const JOB_LISTING_SUGGESTIONS_SUCCESS =
  "JOB_LISTING_SUGGESTIONS_SUCCESS";
export const JOB_LISTING_SUGGESTIONS_FAILED = "JOB_LISTING_SUGGESTIONS_FAILED";

// JOB Status
export const JOB_STATUS = "JOB_STATUS";
export const JOB_STATUS_SUCCESS = "JOB_STATUS_SUCCESS";
export const JOB_STATUS_FAILED = "JOB_STATUS_FAILED";

//popup data
export const POST_POPUP_DATA = "POST_POPUP_DATA";
export const POST_POPUP_DATA_SUCCESS = " POST_POPUP_DATA_SUCCESS";
export const POST_POPUP_DATA_FAIL = "POST_POPUP_DATA_FAIL";

// Delete candidate on candidate pool
export const DELETE_CANDIDATE_ON_CANDIDATEPOOL =
  "DELETE_CANDIDATE_ON_CANDIDATEPOOL";
export const DELETE_CANDIDATE_ON_CANDIDATEPOOL_SUCCESS =
  "DELETE_CANDIDATE_ON_CANDIDATEPOOL_SUCCESS";
export const DELETE_CANDIDATE_ON_CANDIDATEPOOL_FAILED =
  "DELETE_CANDIDATE_ON_CANDIDATEPOOL_FAILED";

// Generate Matching Score
export const GENERATE_MATCHING_SCORE = "GENERATE_MATCHING_SCORE";
export const GENERATE_MATCHING_SCORE_SUCCESS =
  "GENERATE_MATCHING_SCORE_SUCCESS";
export const GENERATE_MATCHING_SCORE_ERROR = "GENERATE_MATCHING_SCORE_ERROR";

// Matching Weightage
export const GET_DEFAULT_WEIGHTAGE = "GET_DEFAULT_WEIGHTAGE";
export const GET_DEFAULT_WEIGHTAGE_SUCCESS = "GET_DEFAULT_WEIGHTAGE_SUCCESS";
export const GET_DEFAULT_WEIGHTAGE_ERROR = "GET_DEFAULT_WEIGHTAGE_ERROR";

export const GET_CUSTOM_WEIGHTAGE = "GET_CUSTOM_WEIGHTAGE";
export const GET_CUSTOM_WEIGHTAGE_SUCCESS = "GET_CUSTOM_WEIGHTAGE_SUCCESS";
export const GET_CUSTOM_WEIGHTAGE_ERROR = "GET_CUSTOM_WEIGHTAGE_ERROR";

export const SAVE_CUSTOM_WEIGHTAGE = "SAVE_CUSTOM_WEIGHTAGE";
export const SAVE_CUSTOM_WEIGHTAGE_SUCCESS = "SAVE_CUSTOM_WEIGHTAGE_SUCCESS";
export const SAVE_CUSTOM_WEIGHTAGE_ERROR = "SAVE_CUSTOM_WEIGHTAGE_ERROR";

// Candidate Facets (Filters)
export const GET_CANDIDATE_FACETS = "GET_CANDIDATE_FACETS";
export const GET_CANDIDATE_FACETS_SUCCESS = "GET_CANDIDATE_FACETS_SUCCESS";
export const GET_CANDIDATE_FACETS_ERROR = "GET_CANDIDATE_FACETS_ERROR";

// Filtered Job Portal Candidates
export const GET_FILTERED_JOB_BOARD_CANDIDATES =
  "GET_FILTERED_JOB_BOARD_CANDIDATES";
export const GET_FILTERED_JOB_BOARD_CANDIDATES_SUCCESS =
  "GET_FILTERED_JOB_BOARD_CANDIDATES_SUCCESS";
export const GET_FILTERED_JOB_BOARD_CANDIDATES_ERROR =
  "GET_FILTERED_JOB_BOARD_CANDIDATES_ERROR";

// Job-Based Facets (Recommended Candidates)
export const GET_JOB_BASED_FACETS = "GET_JOB_BASED_FACETS";
export const GET_JOB_BASED_FACETS_SUCCESS = "GET_JOB_BASED_FACETS_SUCCESS";
export const GET_JOB_BASED_FACETS_ERROR = "GET_JOB_BASED_FACETS_ERROR";

// Bulk Generate Matching Score
export const GENERATE_BULK_MATCHING_SCORE = "GENERATE_BULK_MATCHING_SCORE";
export const GENERATE_BULK_MATCHING_SCORE_SUCCESS =
  "GENERATE_BULK_MATCHING_SCORE_SUCCESS";
export const GENERATE_BULK_MATCHING_SCORE_ERROR =
  "GENERATE_BULK_MATCHING_SCORE_ERROR";
